import {Component, DestroyRef, effect, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatDialog} from '@angular/material/dialog';
import {KtTripsFilterService} from '../service/kt-trips-filter.service';
import {KtTripsFilterModalComponent} from '../components/kt-trips-filter-modal/kt-trips-filter-modal.component';

@Component({
  selector: 'app-kt-trips',
  templateUrl: './kt-trips.component.html',
  standalone: false,
})
export class KtTripsComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly dialog = inject(MatDialog);
  private readonly filterService = inject(KtTripsFilterService);

  constructor() {
    effect(() => {
      const open = this.filterService.toggleModal();
      if (!open) return;
      this.openFilters();
    });
  }

  private openFilters(): void {
    const dialog = this.dialog.open(KtTripsFilterModalComponent, {width: '700px'});
    dialog.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.filterService.toggleModal.set(false);
      });
  }
}
